/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNumber from 'lodash/isNumber';

/**
 * Porovnávač obsahových úloh
 *
 * Určuje priority, jaké mají obsahové úlohy mít.
 * Pokud se má přehrávat více úloh zároveň, rozhodne která má přednost.
 *
 * Porovnává se na základě následujících priorit (od nevyšší):
 * 1. {@link ContentTask#priority}
 * 2. {@link ContentTask#id} s typem `number`
 * 3. {@link ContentTask#id} s typem `string`
 */
class ContentTaskComparator {
  /**
   * Porovná dvě obsahové úlohy.
   * @param {ContentTask} a První úloha
   * @param {ContentTask} b Druhá úloha
   * @returns {number} Hodnoty dle `compareFunction` v `Array.sort`:
   * - -1 = První úloha má nižší prioritu než druhá.
   * - 0 = Obě úlohy mají stejnou prioritu.
   * - 1 = První úloha má vyšší prioritu než druhá.
   */
  compare(a, b) {
    const priorityComparation = this.comparePriority(a.priority, b.priority);
    if (priorityComparation !== 0) {
      return priorityComparation;
    }
    return this.compareId(a.id, b.id);
  }

  /**
   * Porovná dvě obsahové úlohy.
   * @param {DsId} a
   * @param {DsId} b
   * @private
   * @returns {number}
   */
  compareId(a, b) {
    const aIsNumber = isNumber(a);
    const bIsNumber = isNumber(b);
    if (aIsNumber) {
      if (!bIsNumber || a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    } else if (bIsNumber) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }

  /**
   * Porovná dvě obsahové úlohy.
   * @param {number} a
   * @param {number} b
   * @private
   * @returns {number}
   */
  comparePriority(a, b) {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }
    return 0;
  }
}

export default ContentTaskComparator;
